export default __webpack_public_path__ + "static/media/welcome.57fad2d8.png";